export default __webpack_public_path__ + "static/media/bronzeClass.8d6cc0c9.png";